import { render, staticRenderFns } from "./SliderGallery.vue?vue&type=template&id=59f7216e&scoped=true"
import script from "./SliderGallery.vue?vue&type=script&lang=js"
export * from "./SliderGallery.vue?vue&type=script&lang=js"
import style0 from "./SliderGallery.vue?vue&type=style&index=0&id=59f7216e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f7216e",
  null
  
)

export default component.exports